// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay{z-index:990;position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;visibility:hidden;background-color:transparent;transition:.2s}.overlay--shown{opacity:1;visibility:visible;background-color:rgba(9,36,51,.65)}", ""]);
// Exports
module.exports = exports;
